import { render, staticRenderFns } from "./ViewPartners.vue?vue&type=template&id=70b548fc&scoped=true"
import script from "./ViewPartners.vue?vue&type=script&lang=js"
export * from "./ViewPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b548fc",
  null
  
)

export default component.exports